module.exports = __webpack_public_path__ + "img/media-folder-minus.8137195a.svg";